export default (start = 0) => {
    let order = start;

    return () => {
        order++;
        return order;
    };
};
